import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import { mapActions, mapState } from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      pageOrder: 'desc',
      pageSort: 'id',
      centerHeight: document.documentElement.clientHeight - 150 + 'px',
      type: '0',
      searchInput: '',
      myOrderListInfo: [],
      montyTotal: ''
    }
  },
  computed: {
    ...mapState('myOrderModule', ['myOrderList']),
    isNotPaid () {
      return this.myOrderListInfo && this.myOrderListInfo[0] &&
        this.myOrderListInfo[0].comprehensiveStatusName === '未支付'
    }
  },
  methods: {
    dateFormat (time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    purchase () {
      this.$router.push({
        path: RoutePathConstants.PAYMENT_DETAILS,
        query: {
          data: JSON.stringify(this.myOrderListInfo),
          returnData: JSON.stringify(this.myOrderListInfo)
        }
      })
    }
  },
  mounted () {
    document.title = '订单详情'
    this.myOrderListInfo = JSON.parse(this.$route.query.list)
    this.myOrderListInfo[0].commodityQty = this.myOrderListInfo[0].redeemQty
    if (this.myOrderListInfo[0].paymentMethod === 1000) {
      this.montyTotal = '立即兑换  ' + this.myOrderListInfo[0].commodityStoredValueCard * (this.myOrderListInfo[0].commodityQty * 1) + '储值金'
    } else if (this.myOrderListInfo[0].paymentMethod === 2000) {
      this.montyTotal = '立即兑换  ' + this.myOrderListInfo[0].commodityPoints * (this.myOrderListInfo[0].commodityQty * 1) + '积分'
    } else if (this.myOrderListInfo[0].paymentMethod === 3000) {
      this.montyTotal = '立即购买  ' + this.myOrderListInfo[0].commodityCash * (this.myOrderListInfo[0].commodityQty * 1) + '元'
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-order/views/my-order-details.js